// Auth
export const ADMIN_LOGIN = "Accounts/Login";
export const FORGOT_PASSWORD = "Accounts/ForgotPassword";
export const RESET_PASSWORD = "Accounts/ResetPassword";
export const CHANGE_PASSWORD = "Accounts/ChangePassword";

//Common Form API's (no use)
export const GET_ALL_DETAILS = "admin/Blog/GetBlogsList";
export const ADD_DETAILS = "admin/Blog/AddBlog";
export const UPDATE_DETAILS = "admin/Blog/UpdateBlog";
export const DELETE_DATA = "admin/Blog/DeleteBlogImage";

//Assessment Type
export const ADD_ASSESSMENTTYPE = "admin/Assessment/AddAssessmentType"; //POST
export const GET_ASSESSMENTTYPES = "admin/Assessment/GetAssessmentTypes"; //GET
export const UPDATE_ASSESSMENTTYPE = "admin/Assessment/UpdateAssessmentType"; //POST
export const DELETE_ASSESSMENTTYPE = "admin/Assessment/DeleteAssessmentType"; //DELETE

export const ADD_ASSESSMENTTYPE_SCHEDULE = "admin/Assessment/AddAssessmentTypeSchedule"; //POST
export const GET_ASSESSMENTTYPE_SCHEDULE = "admin/Assessment/GetAssessmentTypeSchedules"; //GET

//Grades
export const GET_ALL_GRADES = "admin/Assessment/GetGrades";

//Modules
export const GET_MODULES_BY_GRADE = "admin/Assessment/GetAssessmentModules";
export const ADD_MODULE = "admin/Assessment/AddAssessmentModule";
export const UPDATE_MODULE = "admin/Assessment/UpdateAssessmentModule";
export const DELETE_MODULE = "admin/Assessment/DeleteAssessmentModule";

//Syllabus
export const GET_SYLLABUS = "admin/Assessment/GetAssessmentSyllabuses";
export const ADD_SYLLABUS = "admin/Assessment/AddAssessmentSyllabus";
export const UPDATE_SYLLABUS = "admin/Assessment/UpdateAssessmentSyllabus";
export const DELETE_SYLLABUS = "admin/Assessment/DeleteAssessmentSyllabus";

//Questions
export const GET_QUESTIONS_BY_MODULE = "admin/Assessment/GetAssessmentTemplate";
export const ADD_QUESTION = "admin/Assessment/AddAssessmentQuestion";
export const UPDATE_QUESTION = "admin/Assessment/UpdateAssessmentQuestion";
export const DELETE_QUESTION = "admin/Assessment/DeleteAssessmentQuestion";
export const DELETE_QUESTIONS_BULK = "admin/Assessment/DeleteAssessmentQuestions";
export const GET_QUESTION_HISTORY = "admin/Assessment/GetQuestionHistory";
export const RESTORE_QUESTION_VERSION = "admin/Assessment/RestoreQuestionVersion";
export const GET_RECENT_QUESTION_CHANGES = "admin/Assessment/GetRecentQuestionChanges";

//Students
export const GET_ALL_STUDENTS = "admin/Assessment/GetStudentAssessments";
export const DELETE_STUDENT_BY_ID = "admin/Assessment/DeleteStudentAssessment";
export const DOWNLOAD_STUDENT_REPORT = "admin/Assessment/DownloadAssessmentReport";
export const STUDENT_ASSESSMENT_BY_ID = "admin/Assessment/GetStudentAssessmentById";

//Manage Team
export const ADD_STAFF = "admin/Team/AddTeam"; //postApi
export const GET_ALL_STAFFS = "admin/Team/GetTeamsList"; //postApi
export const UPDATE_STAFF = "admin/Team/UpdateTeam"; //postApi
export const DELETE_STAFF = "admin/Team/DeleteTeams"; //postApi
export const GET_STAFF_BY_ID = "admin/Team/GetTeamById"; //postApi
export const CHANGE_STAFF_STATUS = "admin/Team/EnableDisableTeams"; //postApi
export const GET_ALL_MODULES = "DropDown/GetModuleDropDown"; //getApi

//Branch
export const ADD_BRANCH = "admin/Branch/AddBranch"; //postApi
export const GET_ALL_BRANCH = "admin/Branch/GetBranches"; //getApi
export const UPDATE_BRANCH = "admin/Branch/UpdateBranch"; //postApi
export const DELETE_BRANCH = "admin/Branch/DeleteBranch"; //postApi
export const GET_BRANCH_BY_ID = "admin/Branch/GetBranchById"; //postApi

//Dashboard
export const DASHBOARD_API = "admin/Dashboard/GetParticipationSummary"; //postApi

//Download Bulk Report
export const DOWNLOAD_BULK_REPORT = "admin/Assessment/DownloadBulkAssessmentReports" //postApi